import {
  Button,
  Box,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Input,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { useEffect, useState } from "react";
import { useUiStore } from "hooks/useUiStore";
import Tribunal from "../../assets/images/tribunal-tarde.jpg";
import TribunalNoche from "../../assets/images/tribunal-noche.jpg";
import RuleIcon from "@mui/icons-material/Rule";
import { FaHandshake } from "react-icons/fa";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import PeopleIcon from "@mui/icons-material/People";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import WorkIcon from "@mui/icons-material/Work";
import DoNotTouchIcon from "@mui/icons-material/DoNotTouch";
import { BsVectorPen } from "react-icons/bs";
import { BsWhatsapp } from "react-icons/bs";
import VideoSettingsIcon from "@mui/icons-material/VideoSettings";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import { FaWhatsappSquare } from "react-icons/fa";
import { InputForm } from "components/ui/inputForm";
import { FormProvider, useForm } from "react-hook-form";
import { DarkMode } from "layouts/admin/components/darkMode";
import Acuerdo2010 from "../../assets/pdf/normatividad/Acuerdo_RegistroCedulas.pdf";
import Circular9_2018 from "../../assets/pdf/normatividad/Circular9_2018ReglamentoTribunal.pdf";
import Circular20_2018 from "../../assets/pdf/normatividad/Circular20_2018CreacionJuzgadoFamiliarenLinea.pdf";
import Circular25_2019 from "../../assets/pdf/normatividad/circular25_2019juzgadoCivilEnlinea.pdf";
import Circular26_2019 from "../../assets/pdf/normatividad/26-2019entradaVigorTribunalElectrónico.pdf";
import Circular7_2020 from "../../assets/pdf/normatividad/Circular7_2020lineamientosTribunalLaboral.pdf";
import Circular81_2021 from "../../assets/pdf/normatividad/CIRCULAR81_2021jdoViolenciaFamiliar-SeCrea.pdf";
import Circular89_2021 from "../../assets/pdf/normatividad/CIRCULAR89FirmaElectrOnica.pdf";
import Circular87_2022 from "../../assets/pdf/normatividad/CIRCULAR87_2022_Notificacion-Whatsapp.pdf";
import Circular44_2023 from "../../assets/pdf/normatividad/CIRCULAR44_2023LineamintosStreaming.pdf";
import Circular18_2024 from "../../assets/pdf/normatividad/CIRCULAR18_2024CEROPAPELFAMILIAR.pdf";
import Circular38_2025 from "../../assets/pdf/normatividad/CIRCULAR38_2025notificacionesWhatsapp.pdf";
import Circular24_2025 from "../../assets/pdf/normatividad/circular24_2025ceroPapelcivil.pdf";

import { useAuthStore } from "hooks/useAuthStore";
import { useReSizeWindow } from "hooks/useResizeWindow";

interface cardItem {
  id: number;
  icono: any;
  title: string;
  text: string;
  link: string;
  link2?: string;
  nombre: string;
  nombre2?: string;
  despliega: boolean;
  circular?: string;
  circular2?: string;
}

const cardData: cardItem[] = [
  {
    id: 1,
    icono: <FaHandshake size={80} />,
    title:
      "Acuerdo del 2010. Acuerdo para el Registro de Cedulas Profesionales",
    nombre: "Acuerdo2010.pdf",
    text: "El Código de Procedimientos Civiles del Estado señala que los abogados que intervengan en procesos judiciales cuenten con título y cédula profesional, salvo en casos de violencia familiar, donde, según proceda, se designará un defensor público.",
    link: Acuerdo2010,
    despliega: false,
  },
  {
    id: 2,
    icono: <RuleIcon sx={{ fontSize: 80 }} />,
    title: "Circular  91/2018. Reglamento del Tribunal Electrónico",
    nombre: "Circular91/2018.pdf",
    nombre2: "Circular26/2019.pdf",
    text: "Con el reglamento del Tribunal Electronico, se regula el acceso y uso del sistema digital para gestionar procesos judiciales garantizando seguridad, eficiencia y transparencia, bajo la supervisión del Consejo de la Judicatura.",
    link: Circular9_2018,
    link2: Circular26_2019,
    circular: "Circular 91/2018",
    circular2: "Circular 26/2019",
    despliega: true,
  },
  {
    id: 3,
    icono: <FamilyRestroomIcon sx={{ fontSize: 80 }} />,
    title: "Circular 20/2018. Se crea Juzgado Familiar en Línea y Reglamento",
    nombre: "Circular20/2018.pdf",
    text: "La creación del Juzgado Familiar en Línea tiene como objetivo modernizar la función jurisdiccional, eficientar procesos judiciales en materia Familiar, optimizar recursos, reducir uso de papel, y ofrecer mayor rapidez implementando soluciones tecnológicas en beneficio de los ciudadanos.",
    link: Circular20_2018,
    despliega: false,
  },
  {
    id: 4,
    icono: <PeopleIcon sx={{ fontSize: 80 }} />,
    title: "Circular 25/2019. Se crea Juzgado Civil en Línea y Reglamento",
    nombre: "Circular25/2019.pdf",
    text: "El Consejo de la Judicatura del Estado de México creó el Juzgado Civil en Línea para agilizar trámites no contenciosos, en cumplimiento del Plan de Desarrollo Estratégico 2015-2020 y el Código de Procedimientos Civiles (art. 1.119 Bis).",
    link: Circular25_2019,
    despliega: false,
  },
  {
    id: 5,
    icono: <WorkIcon sx={{ fontSize: 80 }} />,
    title: "Circular  7/2020.	Lineamientos del Tribunal Laboral",
    nombre: "Circular7/2020.pdf",
    text: "El Consejo de la Judicatura del Estado de México emitió un acuerdo para modernizar el sistema de justicia laboral, incluyendo la materia Laboral al reglamento del Tribunal Electrónico y creando el Expediente Laboral Electrónico (EXLAB).",
    link: Circular7_2020,
    despliega: false,
  },
  {
    id: 6,
    icono: <DoNotTouchIcon sx={{ fontSize: 80 }} />,
    title:
      "Circular 81/2021.	Se crea Juzgado Familiar de Violencia en Línea y Reglamento",
    nombre: "Circular81/2021.pdf",
    text: "La creación del Juzgado en Línea Especializado en Violencia Familiar del Estado de México, tiene como objetivo atender los casos de violencia familiar, reducir tiempos de respuesta y garantizar la protección de las víctimas, operando todo el día, los 365 días del año.",
    link: Circular81_2021,
    despliega: false,
  },
  {
    id: 7,
    icono: <BsVectorPen size={80} />,
    title:
      "Circular 89/2021.	Reglamento de la Firma Electrónica Judicial del Estado de México",
    nombre: "Circular89/2021.pdf",
    text: "Normativa vigente de la firma electrónica avanzada con validez legal, con el propósito de autentificar, garantizar seguridad y eficiencia en los procesos judiciales electrónicos, bajo los principios de Autenticidad, Equivalencia Funcional, No Repudio, No Discriminación, Seguridad, Integridad, Confidencialidad y Neutralidad Tecnológica.",
    link: Circular89_2021,
    despliega: false,
  },
  {
    id: 8,
    icono: <BsWhatsapp size={80} />,
    title:
      "Notificaciones vía Whatsapp en materia Familiar, Civil y Mercantil con Reglamento",
    nombre: "Circular87/2022.pdf",
    nombre2: "Circular38/2025.pdf",
    text: "Se incorporan notificaciones vía WhatsApp en juicios civiles, mercantiles, familiares para agilizar procesos judiciales, en el marco de uso del Tribunal Electrónico.",
    link: Circular87_2022,
    link2: Circular38_2025,
    despliega: true,
    circular: "Circular 87/2022",
    circular2: "Circular 38/2025",
  },
  {
    id: 9,
    icono: <VideoSettingsIcon sx={{ fontSize: 80 }} />,
    title: "Circular 44/2023.	Reglamento streaming",
    nombre: "Circular44/2023.pdf",
    text: "Normativas de uso del streaming institucional, para obtener la autorización de visualizar audiencias en materia Penal a usuarios del Sistema de Gestión Judicial Penal V2 (SIGEJUPE v2) y través del sistema del Tribunal Electrónico, en el cual se establecen las directrices de consulta.",
    link: Circular44_2023,
    despliega: false,
  },
  {
    id: 10,
    icono: <FolderSharedIcon sx={{ fontSize: 80 }} />,
    title:
      "Juzgados que operan bajo el modelo de gestión “Cero Papel” en materia Familiar, Civil y Mercantil con Reglamento",
    nombre: "Circular18/2024.pdf",
    nombre2: "Circlar24/2025.pdf",
    text: "Normativa bajo el que operan los Juzgados bajo el modelo de gestión operativa Cero Papel en los juzgados de materia Familiar, Civil y Mercantil para modernizar los procesos judiciales, garantizar eficiencia, transparencia mediante el uso exclusivo de expedientes electrónicos.",
    link: Circular18_2024,
    link2: Circular24_2025,
    despliega: true,
    circular: "Circular 18/2024",
    circular2: "Circular 24/2025",
  },
];

interface NormaProps {
  isNormas?: boolean;
}

export const FormNormas = ({ isNormas }: NormaProps) => {
  const { darkMode } = useUiStore();
  const [reducido, setReducido] = useState(false);
  const [dataCard, setDataCard] = useState<cardItem[]>(cardData);
  const methods = useForm();
  const { changeIsNorma } = useAuthStore();
  const { screenIsOnLandscape } = useReSizeWindow();

  const handleDownload = (text: any, pdfFile: any) => {
    const link = document.createElement("a");
    link.href = pdfFile;
    console.log(pdfFile);
    link.download = text;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (isNormas) {
      const timer = setTimeout(() => {
        setReducido(true);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isNormas]);

  useEffect(() => {
    if (
      methods.getValues("filtro") === "" ||
      methods.getValues("filtro") === undefined
    ) {
      setDataCard(cardData);
    } else {
      const filtro = cardData.filter((card) => {
        return card?.title
          ?.toLowerCase()
          .includes(methods.getValues("filtro")?.toLowerCase());
      });
      setDataCard(filtro);
    }
  }, [methods.watch("filtro")]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: reducido ? "250px" : "100vh",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transition: "height 1s ease-in-out",
          paddingBottom: "20px",
          boxShadow:
            darkMode === "light"
              ? "0 10px 30px rgba(236, 189, 189, 0.6)"
              : "0 10px 30px rgba(0, 0, 0, 0.6)",
          borderRadius: "0px",
          zIndex: 1,
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              darkMode === "light"
                ? `url(${Tribunal})`
                : `url(${TribunalNoche})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            opacity: darkMode === "light" ? 0.4 : 0.7,
            zIndex: -1,
          },
        }}
      >
        <h2
          className="text-9xl font-bold text-center mb-4 ml-4"
          style={{
            fontFamily: "serif",
            fontSize: "clamp(2rem, 6vw, 6rem)",
            letterSpacing: "15px",
            color: darkMode === "light" ? "#000000" : "#ffffff",
          }}
        >
          NORMATIVIDAD
        </h2>
      </Box>
      <Grid container spacing={2} sx={{ padding: 2 }}>
        <Grid item xs={12} md={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-start", p: 2 }}>
            <Link to="/login">
              <Button
                startIcon={<FiArrowLeft />}
                type="button"
                variant="contained"
                color="error"
                onClick={() => changeIsNorma(false)}
              >
                REGRESAR
              </Button>
            </Link>
          </Box>
                      {screenIsOnLandscape ? null : (
              <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: -7 }}>
                <DarkMode />
              </Box>
            )}
        </Grid>

        <Grid item xs={12} md={4}>
          <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
            <FormProvider {...methods}>
              <form style={{ width: "60%" }}>
                {darkMode === "light" ? (
                  <InputForm
                    name="filtro"
                    label="Buscar..."
                    size="small"
                    fullWidth
                  />
                ) : (
                  <Card
                    sx={{
                      padding: 2,
                      width: "100%",
                      backgroundColor: "#454545",
                    }}
                  >
                    <InputForm
                      name="filtro"
                      label="Buscar..."
                      size="small"
                      fullWidth
                    />
                  </Card>
                )}
              </form>
            </FormProvider>
          </Box>
        </Grid>
        {screenIsOnLandscape ? (
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
              <DarkMode />
            </Box>
          </Grid>
        ) : null}
      </Grid>

      {(() => {
        const rows = [];
        for (let i = 0; i < dataCard.length; i += 3) {
          const rowCards = dataCard.slice(i, i + 3);
          rows.push(
            <Grid
              container
              spacing={2}
              justifyContent={rowCards.length < 3 ? "center" : "flex-start"}
              key={`row-${i}`}
              sx={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {rowCards.map((card) => (
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} key={card.id}>
                  <Card
                    sx={{
                      borderRadius: "10px",
                      marginY: "10px",
                      padding: "10px",
                      marginTop: "10px",
                      minHeight: { md: "400px", lg: "310px" },
                      minWidth: { md: "200px", lg: "110px" },
                      width: "100%",
                      height: "100%",
                      backgroundColor:
                        darkMode === "light" ? "#ffffff" : "#454545",
                    }}
                  >
                    <CardHeader
                      subheader={
                        <Typography variant="h6">{card?.title}</Typography>
                      }
                    />
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={12} lg={4} xl={4}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                              gap: 1,
                              marginTop: 2,
                              marginBottom: 2,
                            }}
                          >
                            {card?.icono}
                            {card?.despliega ? (
                              <>
                                <a
                                  onClick={() =>
                                    handleDownload(card?.nombre, card?.link)
                                  }
                                  className="hover:underline cursor-pointer font-bold"
                                  style={{
                                    color:
                                      darkMode === "light"
                                        ? "#657cd1"
                                        : "#8bacd8",
                                    textAlign: "center",
                                  }}
                                >
                                  {card?.circular}
                                </a>
                                <a
                                  onClick={() =>
                                    handleDownload(card?.nombre2, card?.link2)
                                  }
                                  className="hover:underline cursor-pointer font-bold"
                                  style={{
                                    color:
                                      darkMode === "light"
                                        ? "#657cd1"
                                        : "#8bacd8",
                                    textAlign: "center",
                                  }}
                                >
                                  {card?.circular2}
                                </a>
                              </>
                            ) : (
                              <a
                                onClick={() =>
                                  handleDownload(card?.nombre, card?.link)
                                }
                                className="hover:underline cursor-pointer font-bold"
                                style={{
                                  color:
                                    darkMode === "light"
                                      ? "#657cd1"
                                      : "#8bacd8",
                                  textAlign: "center",
                                }}
                              >
                                Consultar aquí
                              </a>
                            )}
                          </Box>
                        </Grid>
                        <Grid item xs={12} lg={8} xl={8}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "normal",
                              justifyContent: "flex-end",
                              height: "100%",
                            }}
                          >
                            <Typography variant="body1" textAlign="justify">
                              {card?.text}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          );
        }
        return rows;
      })()}
    </>
  );
};
